import axios from 'axios'

async function send_train_test(data,token,setOpen,setMessage,setSubmitting,setQuestion,setResponse,setHasEnded,setCount,setIsPaused,setDiv,setHistory,setScore){

    setSubmitting(true)
    setIsPaused(true)

    const URL = `${process.env.REACT_APP_SERVER_AUTH_URL}send-train-test/`

      const sendTest = await axios.post(URL,data,{ 
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${token}`
              }
       }).catch(err=>{console.log(err)})

      if (sendTest?.status == 200 && sendTest?.data.success) {

        if (sendTest?.data?.question?.hasEnded) {
          setSubmitting(false)
          setResponse("")
          setQuestion(sendTest?.data.question)
          // setHistory(sendTest?.data.history)
          setIsPaused(true)
          setDiv(0)
          setScore(sendTest?.data?.question?.total_score)
          setHasEnded(true)
        } else {
          setSubmitting(false)
          setResponse("")
          setQuestion(sendTest?.data.question)
          setHistory(sendTest?.data.history)
          setIsPaused(false)
          setDiv((data?.test.time*60)/data?.test.questions)
        }
        setCount((dat) => dat + 1)
      }else{
        setOpen(true)
        setMessage(sendTest?.data?.message)
        setSubmitting(false)
        setIsPaused(true)
      }
}

export default send_train_test